require('../../modules/es6.math.trunc');
module.exports = require('../../modules/_core').Math.trunc;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/trunc.js
// module id = 1085
// module chunks = 1